module.exports = __webpack_public_path__ + "static/media/pause.fa940eb9.svg";